import { createSlice } from "@reduxjs/toolkit"

export const bannerSlice = createSlice({
	name: "hero_banner",
	initialState: {
		hero_banner: [],
		errors: [],
	},

	reducers: {
		getHeroBanner: (state, action) => {
			// console.log(action.payload)
			state.hero_banner = action.payload
		},
		getHeroBannerSuccess: (state, action) => {
			state.hero_banner = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})

// Action creators are generated for each case reducer function
export const {getHeroBanner, getHeroBannerSuccess,getErrors} = bannerSlice.actions

export default bannerSlice.reducer
